'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of refill
 */ const Refill = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M36.1475 41.0562V37.6673H36.6348C37.7132 37.6673 38.5875 36.793 38.5875 35.7146V33.2047C38.5875 32.1262 37.7132 31.252 36.6348 31.252H18.1798C17.1014 31.252 16.2271 32.1262 16.2271 33.2047V35.7146C16.2271 36.793 17.1014 37.6673 18.1798 37.6673H18.6671V41.1063C17.3282 41.5953 16.1736 42.4748 15.3583 43.6269C14.5429 44.7791 14.1057 46.1486 14.1055 47.5518V70.0442C14.1055 71.1226 14.9797 71.9969 16.0582 71.9969H38.9039C39.9823 71.9969 40.8566 71.1226 40.8566 70.0442V47.5549C40.8566 46.1253 40.403 44.7312 39.5591 43.5665C38.7151 42.4018 37.5226 41.5244 36.1475 41.0562Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M85.0069 41.0562V37.6673H85.4941C86.5726 37.6673 87.4468 36.793 87.4468 35.7146V33.2047C87.4468 32.1262 86.5726 31.252 85.4941 31.252H67.0392C65.9608 31.252 65.0865 32.1262 65.0865 33.2047V35.7146C65.0865 36.793 65.9608 37.6673 67.0392 37.6673H67.5264V41.1063C66.1876 41.5953 65.033 42.4748 64.2176 43.6269C63.4023 44.7791 62.9651 46.1486 62.9648 47.5518V70.0442C62.9648 71.1226 63.8391 71.9969 64.9175 71.9969H87.7633C88.8417 71.9969 89.716 71.1226 89.716 70.0442V47.5549C89.7159 46.1253 89.2624 44.7312 88.4184 43.5665C87.5745 42.4018 86.382 41.5244 85.0069 41.0562Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "16.0586",
                y: "31.2637",
                width: "22.4752",
                height: "6.42148",
                rx: "1.34453",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "64.918",
                y: "31.2637",
                width: "22.4752",
                height: "6.42148",
                rx: "1.34453",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3427_22410)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M68.4218 77.754C67.7024 77.0991 66.5915 77.2078 65.9916 77.977C65.9472 78.0355 65.9027 78.0912 65.8555 78.147C62.9588 81.8146 58.8123 84.1249 54.1908 84.6489C49.8443 85.1394 45.5672 83.9828 42.04 81.4244L43.2593 79.8776C43.8258 79.1642 43.337 78.0884 42.4344 78.055L36.1993 77.7624C35.4522 77.7289 34.8857 78.4507 35.0884 79.1809L36.7437 85.2481C36.9909 86.1399 38.124 86.3684 38.6906 85.6549L39.9765 84.0385C44.2063 87.1432 49.3333 88.5506 54.5574 87.9569C60.0759 87.341 65.0112 84.5903 68.4607 80.2177C68.5162 80.148 68.5717 80.0783 68.6245 80.0058C69.1522 79.3175 69.0606 78.3365 68.419 77.754H68.4218Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M35.5924 25.5528C36.3117 26.2077 37.4226 26.0991 38.0225 25.3326C38.067 25.2741 38.1114 25.2184 38.1586 25.1626C41.0554 21.495 45.2019 19.1847 49.8234 18.6607C54.1699 18.1702 58.4469 19.3268 61.9741 21.8852L60.7549 23.432C60.1883 24.1454 60.6771 25.2212 61.5797 25.2546L67.8148 25.5472C68.5619 25.5807 69.1285 24.8589 68.9258 24.1287L67.2705 18.0616C67.0233 17.1697 65.8901 16.9412 65.3236 17.6547L64.0377 19.2711C59.8078 16.1637 54.6809 14.7563 49.4568 15.3499C43.9355 15.963 39.0029 18.7165 35.5535 23.0892C35.498 23.1588 35.4424 23.2285 35.3896 23.301C34.862 23.9893 34.9536 24.9703 35.5952 25.5528H35.5924Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M14.1016 67.5625H40.9042V70.087C40.9042 71.1599 40.0345 72.0296 38.9617 72.0296H16.0442C14.9713 72.0296 14.1016 71.1599 14.1016 70.087V67.5625Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_22410",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "33.9221",
                        height: "72.8698",
                        fill: "white",
                        transform: "translate(35.0469 15.2168)"
                    })
                })
            })
        ]
    });
};

exports.Refill = Refill;
//# sourceMappingURL=Refill.cjs.map
